/**
 * The four interface locales Exanabi supports.
 *
 * This is the ONLY place the locale list is declared. The frontend (URL
 * prefixes, message loading, the locale switcher) and the backend (profile
 * `uiLocale` validation, Google sign-in redirect locale, email templates)
 * both read from here, so adding a fifth locale is a one-line change.
 *
 * Note: this is the *interface* locale list (what language the UI speaks),
 * not the *content* language list (what language is being tested/learned) —
 * see ../languages/content-languages.ts. The two are deliberately independent.
 */
export const LOCALES = ["en", "tr", "ru", "uz"] as const;

export type AppLocale = (typeof LOCALES)[number];

// Uzbek: most visitors are in Uzbekistan. Also the SEO x-default and the Google sign-in fallback;
// the browser-language detection treats an English browser as "no preference" (see routing.ts).
export const DEFAULT_LOCALE: AppLocale = "uz";

export function isAppLocale(value: string | null | undefined): value is AppLocale {
  return (LOCALES as readonly string[]).includes(value ?? "");
}
